
import { AfterViewInit, Component, Inject, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, NgForm, Validators } from '@angular/forms';
import { JwtTokenService } from './jwt-token.service';
import { AuthService } from '../../../../core/auth.service';
import { BaseService } from '../../../../shared/base.service';
import { ClinicsService } from '../../../../clinics/clinics.service';
import { BaseComponent } from '../../../../shared/base.component';
import { AppService } from '../../../../app.service';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { UsersService } from '../../../../users/users.service';
import { HomeService } from '../../../home.service';
import { MaintenanceService } from '../../../../maintenance/maintenance.service';
import { SecureApi } from '../../../../core/secure.api';
import {CoreService} from "../../../../core/core.service";
import {B2CAdminComponent} from "../../b2c-admin.component";
import {MaintenanceComponent} from "../../../../maintenance/maintenance.component";
import {DOCUMENT} from '@angular/common';


@Component({
    selector: 'jwt-token-component',
    templateUrl: './jwt-token.component.html',
    styleUrls: ['./jwt-token.component.scss'],
    providers: [JwtTokenService]
})

export class JwtTokenComponent extends B2CAdminComponent implements OnInit {
    token = '';
    tokenUrl = '';
    baseUrl = '';

    constructor(public authService: AuthService,
                public coreService: CoreService,
                public router: Router,
                public translate: TranslateService,
                public fb: FormBuilder,
                public baseService: BaseService,
                public appService: AppService,
                public usersService: UsersService,
                public homeService: HomeService,
                public clinicService: ClinicsService,
                public maintenanceService: MaintenanceService,
                public secureApi: SecureApi,
                public maintenanceComponent: MaintenanceComponent,
                @Inject(DOCUMENT) private document: Document,
                public service: JwtTokenService)  {
        super(authService, coreService, router, translate, fb, baseService, appService, usersService, homeService, clinicService, maintenanceService, secureApi, maintenanceComponent);
    }

    ngOnInit() {
        super.ngOnInit();
        this.buildForm();
        this.baseUrl = this.document.location.origin;
        this.clinicService.getAllB2C()
            .subscribe(
                response => {
                    this.clinics = response['items'];
                    this.clinics.forEach(clinic => {
                        if (clinic['is_default']) {
                            this.form.controls['clinic_id'].setValue(clinic['id']);
                        }
                    });
                });
    }

    buildForm(): void {
        this.form = this.fb.group({
            'clinic_id': ['', [Validators.required]],
            'userId': ['', [Validators.required]],
        });
    }

    submit(value, isValid) {
        this.formSubmitted = true;
        if (!isValid) {
            return;
        }

        this.appService.isLoading = true;
        this.service.generateToken(value).subscribe(res => {
            this.appService.isLoading = false;
            this.token = res['token'];
            this.tokenUrl = this.baseUrl + '/me/register/jwt?token=' + res['token'];
        });
    }
}
